import { render, staticRenderFns } from "./childInfoModal.vue?vue&type=template&id=fb310236"
import script from "./childInfoModal.vue?vue&type=script&lang=js"
export * from "./childInfoModal.vue?vue&type=script&lang=js"
import style0 from "./childInfoModal.vue?vue&type=style&index=0&id=fb310236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports